import axios from "../axiosPlugin.js";

const _VERSION_API = "/api/version";
const _OTHER_VERSION_API = "/api/otherVersion";

/* Version services */
export const getVersionService = data => {
  return axios({
    url: `${_VERSION_API}/list`,
    method: "get",
    data: { data },
  });
};

export const delVersionService = data => {
  return axios({
    url: `${_VERSION_API}/delete/${data.vid}`,
    method: "get",
    data: { data },
  });
};

export const addVersionService = data => {
  return axios({
    url: `${_VERSION_API}/create`,
    method: "post",
    data: { data },
  });
};

export const updateVersionService = data => {
  return axios({
    url: `${_VERSION_API}/update`,
    method: "post",
    data: { data },
  });
};

/* Other Version services */
export const getOtherVersionService = data => {
  return axios({
    url: `${_OTHER_VERSION_API}/List`,
    method: "get",
    data: { data },
  });
};

export const delOtherVersionService = data => {
  return axios({
    url: `${_OTHER_VERSION_API}/delete/${data.vid}`,
    method: "get",
    data: { data },
  });
};

export const addOtherVersionService = data => {
  return axios({
    url: `${_OTHER_VERSION_API}/create`,
    method: "post",
    data: { data },
  });
};

export const updateOtherVersionService = data => {
  return axios({
    url: `${_OTHER_VERSION_API}/update`,
    method: "put",
    data: { data },
  });
};